import { AxiosInstance } from "axios";
import { UserResource } from "@datahow/dhljs";

export class UserClient {
    public apiClient: AxiosInstance;

    private current: UserResource | null = null;
    private observers: Array<(user: UserResource) => void> = [];

    constructor(apiClient: AxiosInstance) {
      this.apiClient = apiClient;
    }

    public get currentUser() {
      return this.current;
    }

    public async getCurrentUser() {
      return this.apiClient.get("users/current")
        .then(({ data }: { data: UserResource }) => {
          this.setUser(data);
        });
    }

    public subscribe(fn: (user: UserResource) => void) {
      this.observers.push(fn);
    }

    public unsubscribe(fn: (user: UserResource) => void) {
      this.observers = this.observers.filter((subscriber) => subscriber !== fn);
    }

    private setUser(user: UserResource) {
      this.current = user;
      this.observers.forEach((subscriber) => subscriber(user));
    }
}